import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, ChartDataLabels);

function ByGeography({ chart_data }) {
  const [label, setLabel] = useState([]);
  const [values, setValues] = useState([]);
  const [data, setData] = useState({labels: [], datasets: []});
  const [options, setOptions] = useState({});
  const [regionMapping, setRegionMapping] = useState({});
  const [actualValues, setActualValues] = useState([]);

  useEffect(() => {
    let regions = [];
    let percentages = [];
    let actualAmounts = [];
    let mapping = {};
    let europeTotal = 0;
    let europeAmount = 0;

    let total_amount = chart_data?.reduce(
        (sum, item) => sum + item.total_amount,
        0
    );

    chart_data?.forEach((item) => {
        let percentage = ((item.total_amount / total_amount) * 100);
        let amountInCr = item.total_amount / 10000000; // convert to Cr

        if (item.id === 1) {
        regions.push("MEA");
        percentages.push(percentage.toFixed(1));
        actualAmounts.push(amountInCr);
        mapping["MEA"] = [1];
        } else if (item.id === 4 || item.id === 10) {
        europeTotal += percentage;
        europeAmount += amountInCr;
        } else if (item.id === 6) {
        regions.push("Americas");
        percentages.push(percentage.toFixed(1));
        actualAmounts.push(amountInCr);
        mapping["Americas"] = [6];
        } else if (item.id === 8) {
        regions.push("SEA");
        percentages.push(percentage.toFixed(1));
        actualAmounts.push(amountInCr);
        mapping["SEA"] = [8];
        } else {
        regions.push(item.region_name);
        percentages.push(percentage.toFixed(1));
        actualAmounts.push(amountInCr);
        mapping[item.region_name] = [item.id];
        }
    });

    if (europeTotal > 0) {
        regions.push("Europe");
        percentages.push(europeTotal.toFixed(1));
        actualAmounts.push(europeAmount);
        mapping["Europe"] = [4, 10];
    }

    setLabel(regions);
    setValues(percentages);
    setActualValues(actualAmounts); // 👈 new state
    setRegionMapping(mapping);

    }, [chart_data]);

  let colors = [
    "#FFCE56",
    "#FF9F40",
    "#36A2EB",
    "#4BC0C0",
    "#FF6384",
    "#9966FF",
    "#2ecc71",
  ];

  useEffect(() => {
    if (label.length === 0) return;

    setData({
      labels: label,
      datasets: [
        {
          data: values,
          actualData: actualValues,
          backgroundColor: colors.slice(0, values.length),
          borderWidth: 0,
        },
      ],
    });

    setOptions({
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 40,
          bottom: 40,
          left: 50,
          right: 40,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        datalabels: {
          color: "#000",
          anchor: "end",
          align: "end",
          offset: 8,
          formatter: (value) => {
            return value > 1 ? value + "%" : "";
          },
          font: {
            weight: "bold",
            size: 12,
          },
        },
        tooltip: {
            callbacks: {
                label: (context) => {
                const actual = context.dataset.actualData[context.dataIndex];
                return `${context.label}: ₹ ${actual.toFixed(2)} Cr`;
                },
            },
        },
    },
      onHover: (event, elements) => {
        if (elements.length > 0) {
          event.native.target.style.cursor = "pointer";
        } else {
          event.native.target.style.cursor = "default";
        }
      },
    });
  }, [label, values, regionMapping, colors]);

  return (
    <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
          }}
        >
          {/* LEFT: PIE CHART */}
          <div style={{ width: "60%", height: "250px" }}>
            {data?.datasets?.length > 0 && <Pie data={data} options={options} />}
          </div>
    
          {/* RIGHT: CUSTOM LEGEND */}
          <div style={{ width: "40%", paddingLeft: "20px" }}>
            {label.map((label, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
              >
                <div
                  style={{
                    width: 14,
                    height: 14,
                    backgroundColor: colors[index],
                    marginRight: 10,
                    borderRadius: 4,
                  }}
                ></div>
                <span style={{ fontSize: "14px" }}>
                  {label} – <strong>{values[index]}%</strong>
                </span>
              </div>
            ))}
          </div>
        </div>
  );
}

export default ByGeography;
